import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static values = { requestId: Number }
  static targets = ["title", "events", "status"]

  connect() {
    this.eventCount = 0
    this.calendulateChannel = consumer.subscriptions.create(
      { channel: "CalendulateChannel", id: this.requestIdValue },
      { received: (data) => this.processData(data) }
    )
  }

  disconnect() {
    this.calendulateChannel?.unsubscribe()
  }

  processData(data) {
    if (data.completed) {
      document.getElementById('user_input_block').style.display = 'none'
      const frame = document.getElementById(`calendulate_request_${this.requestIdValue}`)
      if (frame) {
        frame.src = window.location.pathname
      } else {
        Turbo.visit(window.location.pathname)
      }
      return
    }

    // Handle both structured ({type: "event", ...}) and legacy ({status_update: "text"}) formats
    const payload = data.status_update || data

    switch (payload.type) {
      case "title":
        this.titleTarget.textContent = `Extracting events for "${payload.text}"...`
        break
      case "event":
        this.appendEvent(payload)
        break
      case "geocoding":
        this.statusTarget.textContent = payload.text
        this.statusTarget.classList.remove("hidden")
        break
    }
  }

  appendEvent(data) {
    this.statusTarget.classList.add("hidden")
    const existing = this.eventsTarget.querySelector(`[data-event-index="${data.index}"]`)
    if (existing) {
      const nameSpan = existing.querySelector('.event-name')
      if (nameSpan) nameSpan.textContent = data.name
      const emojiSpan = existing.querySelector('.event-emoji')
      if (emojiSpan && data.emoji) emojiSpan.textContent = data.emoji
      return
    }
    const el = document.createElement("div")
    el.className = "animate-slide-in flex items-center gap-2"
    el.dataset.eventIndex = data.index
    el.innerHTML = `<span class="event-name">${this.escapeHtml(data.name)}</span> <span class="event-emoji">${data.emoji || "📅"}</span>`
    this.eventsTarget.appendChild(el)
    this.eventCount = data.index + 1
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
